const qs = require('qs')

export function queryString () {
  return qs.parse(window.location.search.split('?')[1])
}
